import React from 'react';
import { useSearchBar } from '../hooks/useSearchBar';

type SearchBarContainerProps = { children: React.ReactNode };

const SearchBarContainer = ({ children }: SearchBarContainerProps) => {
	const { maxWidth } = useSearchBar();

	const renderStyles = () => {
		if (maxWidth) {
			return {
				maxWidth: maxWidth,
			};
		}
	};

	return (
		<div
			className={`searchBarContainer w-100 mw7 pv4 vtex-store-components-3-x-searchBarContainer`}
			style={renderStyles()}
		>
			{children}
		</div>
	);
};

export default SearchBarContainer;
